import React, { memo, useEffect, useMemo, useState } from 'react'
import { Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { stockroomSelector, getStockroomsAction } from '../../store/stockroom'

const StockroomSelector = ({ value, onChange, mode = null, ...rest }) => {
  const dispatch = useDispatch()
  const { stockrooms } = useSelector(stockroomSelector)
  const [stockroomData, setStockroomData] = useState(stockrooms)

  useEffect(() => {
    if (!stockrooms || stockrooms.length === 0) {
      dispatch(getStockroomsAction({ pagination: {} }))
        .unwrap()
        .then((response) => setStockroomData(response.data))
    }
  }, [dispatch])

  let options = useMemo(
    () => stockroomData?.map((item) => ({ value: item.id, label: item.attributes.name })),
    [stockroomData]
  )

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      mode={mode}
      allowClear
      dropdownMatchSelectWidth={false}
      {...rest}
    />
  )
}

export default memo(StockroomSelector)
